import React, { useState } from "react";
import { Icon, Button } from "antd";
import { printLabels } from "../../../utils/labelUtils";

export default function LabelModal({
  shipmentCode,
  getLabels,
  labelsData,
  labelsIsLoading,
  labelsErrors,
  handleClose,
}) {
  const [printType, setPrintType] = useState(undefined);

  const buttonDisabled = !printType || labelsIsLoading;

  const handlePrintLabels = async () => {
    if (!shipmentCode || !printType) return;

    const printedLabels = await getLabels(shipmentCode, printType);
    if (printedLabels) {
      printLabels(printedLabels);
      handleClose();
    }
  };

  if (labelsIsLoading) {
    return (
      <div className="LabelModal">
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="LabelModal">
              <div className="loading-message-container">
                <span>
                  <b>Descargando etiquetas...</b>
                </span>
              </div>
              <div className="spinner-container">
                <Icon type="sync" spin />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="LabelModal">
      {" "}
      <div className="modal-overlay">
        <div className="modal-container">
          <div className="LabelModal">
            <div className="print-buttons-container">
              <span className="buttons-instruction">
                Seleccione el formato de descarga de la etiqueta:
              </span>
              <div className="buttons-container">
                <Button
                  className={printType === 1 ? "active-button" : null}
                  onClick={() => setPrintType(1)}
                >
                  Formato A4
                </Button>
                <Button
                  className={printType === 2 ? "active-button" : null}
                  onClick={() => setPrintType(2)}
                >
                  Etiquetadora
                </Button>
              </div>
            </div>
            <div className="error-container">
              {labelsErrors?.length > 0 && (
                <small>Error al generar etiqueta. Inténtelo de nuevo.</small>
              )}
            </div>
            <div className="accept-container">
              <Button
                onClick={handlePrintLabels}
                className={buttonDisabled ? "disabled-button" : "accept-button"}
                disabled={buttonDisabled}
              >
                Aceptar
              </Button>
              <Button
                type="danger"
                ghost
                onClick={handleClose}
                className="cancel-button"
              >
                Cerrar
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
